import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Card from '@components/card'
import Title from '@components/text/title'
import FormInput from '@components/inputs/formInput'
import PrimaryButton from '@components/inputs/button/primaryButton'
import Loading from '@components/loading'
import Footer from '@components/footer'
import SubText from '@components/text/subText'
import InsurerLogo from '@components/insurerLogo'
import ReCAPTCHA from 'react-google-recaptcha'
import { RecaptchaContainer } from '@pages/beneficiaryLogin/styles.js'
import { useNavigate } from 'react-router-dom'
import showToast from '@util/ToastUtil'

import colors from '@settings/styleSettings'

import {
  Container, GreenContainer, CardContainer, Box,
} from './styles'

import backgroundImage from '@assets/images/login-background.jpg'
import { validateEmailRecoverPassword } from '@util/validationUtil'

import { passwordRecovery as passwordRecoveryAction } from '@actions/user'

const RecoverPassword = ({ passwordRecovery }) => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [captcha, setCaptcha] = useState(false)
  const [isEmailSent, setIsEmailSent] = useState('')
  const [timer, setTimer] = useState(0)
  const [isButtonDisabled, setIsButtonDisabled] = useState(false)
  const [isResend, setIsResend] = useState(false)

  const recaptchaSiteKey = (
    process.env.REACT_APP_RECAPTCHA_SITE_KEY
    || process.env.REACT_APP_RECAPTCHA
  )
  const showRecaptcha = Boolean(recaptchaSiteKey)

  const navigate = useNavigate()
  const onInputChange = (e, setState) => setState(e.target.value)

  const callback = (data) => {
    if (data && data.message) {
      setErrors({
        ...errors,
        email: data.message.message
      })
    } else {
      setIsEmailSent(email)
      setIsButtonDisabled(true)
      setTimer(30)
      setIsResend(true)
    }
    setLoading(false)
  }

  const validateCaptcha = () => {
    if (!showRecaptcha) return true

    if (!captcha && !isResend) {
      showToast('error', 'É necessário fazer o captcha para prosseguir')
      return false
    }
    return true
  }

  const onClick = () => {
    setLoading(true)
    if (validateCaptcha()) {
      passwordRecovery(email, captcha, isResend, callback)
    }
  }

  const buttonLabel = () => {
    let content
    if (loading) {
      content = <Loading />
    } else if (isEmailSent) {
      content = 'Enviar novamente'
    } else {
      content = 'Enviar'
    }
    return content
  }

  const onChangeRecaptcha = (value) => setCaptcha(value)

  function checkOnUnfocus(label, value) {
    const error = validateEmailRecoverPassword[label](value)
    if (error) {
      setErrors({
        ...errors,
        [label]: error
      })
    } else {
      const aux = errors
      delete aux[label]
      setErrors({ ...aux })
    }
  }

  const goBack = () => {
    navigate(-1)
  }

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1)
      }, 1000)
      return () => clearInterval(interval)
    }
    setIsButtonDisabled(false)
    return undefined

  }, [timer])

  return (
    <Container
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      <GreenContainer>
        <InsurerLogo />
        <Card
          style={{ flex: '0', padding: '40px 24px' }}
        >
          <CardContainer>
            <Box>
              <Title
                style={{ margin: '10px 0' }}
              >
                Recuperar senha
              </Title>
              <SubText
                style={{
                  color: colors.placeholder,
                  textAlign: 'center',
                }}
              >
                {
                isEmailSent
                  ? `Enviamos o link para redefinir sua senha no e-mail ${isEmailSent}`
                  : 'Informe o e-mail cadastrado para enviarmos um link de recuperação de senha'
                }
              </SubText>
            </Box>
            {!isEmailSent && (
              <>
                <FormInput
                  placeholder="Email"
                  value={email}
                  onChange={(e) => onInputChange(e, setEmail)}
                  error={errors.email}
                  onBlur={() => checkOnUnfocus('email', email)}
                />
                <RecaptchaContainer>
                  {showRecaptcha && (
                    <ReCAPTCHA
                      sitekey={recaptchaSiteKey}
                      onChange={onChangeRecaptcha}
                    />
                  )}
                </RecaptchaContainer>
              </>
            )}
            <PrimaryButton disabled={loading || isButtonDisabled} onClick={onClick}>
              {buttonLabel()}
            </PrimaryButton>
            {timer > 0 && (
              <SubText style={{ color: colors.placeholder }}>
                Link reenviado. Aguarde
                {' '}
                {timer}
                {' '}
                segundos antes de tentar reenviar novamente.
              </SubText>
            )}
            <PrimaryButton
              style={{
                backgroundColor: colors.background,
                color: colors.primary
              }}
              onClick={goBack}
            >
              Voltar
            </PrimaryButton>
          </CardContainer>
        </Card>
        <Footer />
      </GreenContainer>
    </Container>
  )
}

RecoverPassword.propTypes = {
  passwordRecovery: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    passwordRecovery: passwordRecoveryAction,
  },
  dispatch
)

export default connect(null, mapDispatchToProps)(RecoverPassword)
